export const fnPopWin = (
  Url: string,
  width: number = 800,
  height: number = 600,
): Window | null => {
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const childWindow = window.open(
    Url,
    "_blank",
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
  );

  // 标识本应用的独立弹窗，避免全局悬浮操作遮挡弹窗底部按钮。
  if (childWindow && new URL(Url, window.location.href).origin === window.location.origin) {
    childWindow.name = "chinaone-popup";
  }
  childWindow?.focus();

  return childWindow;
};
